module.exports = __webpack_public_path__ + "static/media/icon_comment.68cd61f0.svg";